import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

/** Ranking module. */
export const rankingModule = {
    state,
    getters,
    mutations,
    actions,
};
